import styled from 'styled-components'
import { layout, margin, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

export const Container = styled.div.attrs({
  px: [0, 0, 30, 40],
})`
  height: 100%;
  display: flex;

  ${padding}
`

export const Card = styled.div.attrs({
  px: [24, 24, 32],
  pt: [72, 72, 100],
  pb: [32, 32, 40],
})`
  position: relative;
  border-radius: 20px;
  border: 1px solid ${themeGet('colors.softPeach')};

  ${margin}
  ${padding}
  ${layout}
`

export const Avatar = styled.img.attrs({
  size: [100, 100, 140],
})`
  top: 0;
  position: absolute;
  transform: translateY(-50%);

  ${layout}
`
